import { get } from 'lodash';
import moment from 'moment';
import {
  fetchSubjectSuccess,
  fetchSubjectLabelSuccess,
  updateSubjectMemberSuccess,
  createSubjectIndexSuccess
} from './actions';

import { subjectQueryAsync, subjectUpdateAsync } from 'helpers/graphql';
import { minerUpdateAsync, minerQueryAsync } from 'helpers/graphql';
const subjectFragment = `
  on Subject {
    id
    name
    isDailyHot
    image
    createdAt
    updatedAt
    startDate
    endDate
    labels {
      id
      name
      subjectCount
    }
    parentSubjectId
    parentSubject{
      id
      name
      startDate
      endDate
      type
      createdAt
      childSubjects {
        id
        name
        startDate
        endDate
        type
        createdAt
      }
    }
    childSubjects {
      id
      name
      startDate
      endDate
      type
      createdAt
      queries {
        mediaType
        q
        not
        source{
          sourceGroupId
          from
          in
        }
      }
    }
    sourceGroupLabel
    type
    alertEnabled
    alert {
      conditions{
        mediaType
        hours
        field
        type
        value
      }
      emails
      openids {
        name
        openid
        avatar
      }
    }
    autoPoolingEnabled
    autoPoolings {
      mediaType
      hour
      minute
      actions
    }
    members {
      userId
      userName
      groupName
      email
    }
    query {
      q
      not
    }
    queries {
      mediaType
      q
      not
      source{
        sourceGroupId
        from
        in
      }
    }
    dailyEmailEnabled
    dailyEmail{
      hour
      minute
      clientId
      lang
      emails
      mediaType
      isSummaryVisible
    }
  }
`;
const alertSubjectFragment = `
  on Subject {
    id
    name
    isDailyHot
    image
    createdAt
    updatedAt
    startDate
    endDate
    type
    labels {
      id
      name
      subjectCount
    }
    sourceGroupLabel
    type
    alertEnabled
    alert {
      conditions{
        mediaType
        hours
        field
        type
        value
        lastLog{
          startDate
          endDate
          value
          count
        }
      }
      emails
      openids {
        name
        openid
        avatar
      }
    }
    autoPoolingEnabled
    autoPoolings {
      mediaType
      hour
      minute
      actions
    }
    members {
      userId
      userName
      groupName
      email
    }
    query {
      q
      not
    }
    queries {
      mediaType
      q
      not
      source{
        sourceGroupId
        from
        in
      }
    }
  }
`;

export const fetchSubject = ({id, isAppend, name, ids, userId, isPrivate, isForMember, label, type, limit, offset, parentSubjectId}) => {
  let query = `
        query(
          $userId: ID
          $name: String
          $isForMember: Boolean
          $label:String
          $parentSubjectId: String
          $limit: Int
          $offset: Int
          $type: String
          $ids: [ID]
        ) {
          subjects(
            userId: $userId
            name: $name
            parentSubjectId: $parentSubjectId
            isForMember: $isForMember
            label: $label
            type: $type
            limit: $limit
            offset: $offset
            ids: $ids
          ) {
            count
            data {
              ...${subjectFragment}
            }
          }
        }
      `
  return subjectQueryAsync(query, {userId, ids, name, isPrivate, isForMember, label, type, limit, offset, parentSubjectId})
    .then((body) =>
      fetchSubjectSuccess({
        id: id,
        isAppend,
        subjects: get(body, 'data.subjects'),
      })
    );
}

export const fetchAlertSubject = ({id, isAppend, name, ids, userId, isPrivate, isForMember, label, type, limit, offset}) => {
  const query = `
        query(
          $userId: ID
          $name: String
          $isForMember: Boolean
          $label:String
          $type: String
          $limit: Int
          $offset: Int
          $ids: [ID]
        ) {
          subjects(
            userId: $userId
            name: $name
            isForMember: $isForMember
            label: $label
            type: $type
            limit: $limit
            offset: $offset
            ids: $ids
          ) {
            count
            data {
              ...${alertSubjectFragment}
            }
          }
        }
      `
  return subjectQueryAsync(query, {userId, ids, name, isPrivate, isForMember, label, type, limit, offset})
    .then((body) =>
      fetchSubjectSuccess({
        id: id,
        isAppend,
        subjects: get(body, 'data.subjects'),
      })
    );
}

export const pushSubjectMember = (data) => {
  const query = `
        mutation (
          $userId: [String]!
          $subjectId: String!
        ) {
          pushSubjectMember(
            subjectId: $subjectId
            userId: $userId
          ) {
            ...${subjectFragment}
          }
        }
      `
  return subjectUpdateAsync(query, {...data})
    .then((body) =>
      updateSubjectMemberSuccess(body.data.pushSubjectMember)
    );
}

export const removeSubjectMember = (data) => {
  const query = `
        mutation (
          $userId: [String]!
          $subjectId: String!
        ) {
          removeSubjectMember(
            subjectId: $subjectId
            userId: $userId
          ) {
            ...${subjectFragment}
          }
        }
      `
  return subjectUpdateAsync(query, {...data})
    .then((body) =>
      updateSubjectMemberSuccess(body.data.removeSubjectMember)
    );
}

export const createSubjectIndex = (subjectId) => {
  const query = `
        mutation (
          $subjectId: String!
        ) {
          createIndex (
            subjectId: $subjectId
          )
        }
        `
  return minerUpdateAsync(query, subjectId)
    .then((body) =>
      createSubjectIndexSuccess()
    )
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/subject/tasks.js
 **/